import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal, Container, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'


const Grilla = () => {
  const [show, setShow] = useState(false) 
const [listaGrilla,setListaGrilla]= useState('') 
  const data_antecedentes = useSelector((state) => state.AntecedentesJudicialesReducer)
   const { cfg_form27, datosGrilla} = data_antecedentes

 useEffect(()=>{
  setListaGrilla(datosGrilla && datosGrilla.datosGrilla)
 },[datosGrilla])
 useEffect(()=>{
  setListaGrilla('')
 },[])
 const obtenerColumnas = () => {
  return [
    
    
    {
      dataField: 'glosaHito',
      text:cfg_form27 ? cfg_form27.cfg_form27[
        'consultaantecjudicial-grilla-hito'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form27 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fechaHitoFormat',
      text: cfg_form27 ? cfg_form27.cfg_form27[
        'consultaantecjudicial-grilla-fechaocurre'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form27 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'fechaAudienciaFormat',
      text: cfg_form27 ? cfg_form27.cfg_form27[
        'consultaantecjudicial-grilla-fechaaudiencia'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form27 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' }
    },
    {
      dataField: 'comentario',
      text:cfg_form27 ? cfg_form27.cfg_form27[
        'consultaantecjudicial-grilla-comentario'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form27 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: { backgroundColor: '#728bb0', color: 'white' },
      formatter:(cell, row)=>{
        if(cell?.length>30) {
          return <>        
              <a href='#' style={{textDecoration:'none'}} onClick={(e)=>{
                 e.preventDefault()
                alert(cell)}}>{cell?.substring(0,30)}</a>
                
          </>
         }else{
             return cell
         }
       }
    },
    {
      dataField: 'usuario',
      text: cfg_form27 ?cfg_form27.cfg_form27[
        'consultaantecjudicial-grilla-usuario'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
          {cfg_form27 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    
    {
      dataField: 'fechaRegistroHitoFormat',
      text: cfg_form27 ? cfg_form27.cfg_form27[
        'consultaantecjudicial-grilla-fecharegistro'
      ]:'',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
        <div>
           {cfg_form27 && column.text}
          <br />
          {sortElement}
        </div>
      ),
      headerStyle: {
        backgroundColor: '#728bb0',
        color: 'white',
        verticalAlign: 'middle'
      }
    },
    {
        dataField: 'opciones',
        text: '',
        isDummyField: true,
        headerStyle: (colum, colIndex) => {
          return {
            width: '40%',
            textAlign: 'center',
            verticalAlign: 'center',
            backgroundColor: '#728bb0',
            color: 'white'
          }
        },
        style: { textAlign: 'center', verticalAlign: 'middle' },
        formatter: (cell, row) => (
          
         <div>
            {
            parseInt(row.folioCarga) > 0  ? ( <OverlayTrigger
              overlay={<Tooltip id='tooltip-disabled'>Detalles </Tooltip>}
            >
              <Button
                type='button'
                variant='outline-secondary me-md-2'
                size='sm'
               
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                          </svg>
              </Button>
            </OverlayTrigger>):null
            
            }
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      }
    
   
  ]
}

  return (
    <>
     
      <Container>
      
      <Row className='mt-4 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secuencia'
                data={listaGrilla ? listaGrilla : []}
                columns={obtenerColumnas()}
                defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                   

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
       
      </Container>
    </>
  )
}

export default Grilla
